// Libs
import React from 'react'
import { Container, Row, Col } from '../Elemental'

// CSS
import './styles.scss'

// Components/Containers
import CloseIcon from '../CloseIcon'

const Modal = ({ visible, padding, close, children, handleClose, md, lg }) => {
  const modalStyle = {
    padding: `${padding}px`,
  }

  return (
    <div className={visible ? 'modal modal--visible' : 'modal'} onClick={handleClose ? handleClose : null}>
      <div className="modal__background" />
      <Container gutter={0}>
        <Row className="modal__row">
          <Col sm="100%" md={md ? md : "75%"} lg={lg ? lg : "60%"} className="modal__col" onClick={(e) => e.stopPropagation()}>
            <div style={modalStyle} className="modal__wrapper">
              {children}
            </div>
          </Col>
        </Row>
      </Container>
      {visible && handleClose &&
        <div className="modal__close">
          <CloseIcon color="grey" width={30} />
        </div>
      }
    </div>
  )
}

export default Modal
